module.exports = '<svg width="22" height="32" viewBox="0 0 22 32"><path d="M18 2c0-1.106.894-2 2-2s2 .894 2 2v19c0 6.074-4.926 11-11 11S0 27.074 0 21V8a8 8 0 0 1 16 0v13c0 2.762-2.238 5-5 5s-5-2.238-5-5V8a2 2 0 1 1 4 0v13a1 1 0 0 0 2 0V8c0-2.208-1.792-4-4-4S4 5.792 4 8v13c0 3.868 3.134 7 7 7s7-3.132 7-7V2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/paperclip-2.js
// module id = 1327
// module chunks = 14